import logo from "assets/images/logo/Trellis_Logomark_color.png";
import PerfectScrollbar from "react-perfect-scrollbar";
import AdminNavbarLinks from "./NavigationBar";
import ProductOptions from "views/SidebarFragments/ProductOptions";
import MerchantSidebar from "./SidebarFragments/MerchandisingSidebar";
import MobileNavbarTiles from "components/custom/navbar/MobileNavbarTiles";
import { Button } from "components/core/basic/Button";
import { logoutUser } from "redux/reducers/userReducer";
import { HOMEPAGE } from "utils/redirectConstants";
import { DatesProvider } from "dates/DatesContext";
import { useAppDispatch } from "../redux/hooks";
import { useWindowSize } from "usehooks-ts";

function Sidebar() {
  const dispatch = useAppDispatch();
  const { width } = useWindowSize();

  const onLogoutClick = () => {
    dispatch(logoutUser());
  };

  return (
    <DatesProvider>
      <div className="sidebar" data-color="gv-light">
        <div
          className="logo d-flex border-bottom"
          style={{
            zIndex: 10000,
            backgroundColor: "#F5F3F6",
          }}
        >
          <div className={`text-center ${width <= 992 ? "me-auto" : "mx-auto"}`}>
            <a href={HOMEPAGE} className="simple-text logo-mini" target="_blank" rel="noopener noreferrer">
              <div className="logo-img">
                <img src={logo} alt="G" />
              </div>
            </a>
            <a
              href={HOMEPAGE}
              className="simple-text logo-normal"
              target="_blank"
              rel="noopener noreferrer"
              style={{ width: "120px" }}
            >
              <div
                style={{
                  textTransform: "lowercase",
                  fontSize: "24px",
                  fontWeight: "bolder",
                  color: "#2e0054",
                  marginRight: "20px",
                  paddingTop: ".7rem",
                }}
              >
                trellis
              </div>
            </a>
          </div>
          {width <= 992 && (
            <div
              style={{
                zIndex: 11000,
                position: "absolute",
                right: "100px",
                top: "22px",
              }}
            >
              <Button onPress={onLogoutClick}>Logout</Button>
              <span
                onClick={() => document.documentElement.classList.toggle("nav-open")}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "50px",
                  height: "50px",
                  color: "#2e0054",
                  position: "fixed",
                  top: "15px",
                  right: "25px",
                  cursor: "pointer",
                  fontSize: "2rem",
                  fontWeight: 700,
                }}
              >
                &#10005;
              </span>
            </div>
          )}
        </div>

        <PerfectScrollbar
          className={`sidebar-wrapper`}
          style={{
            background: "#F5F3F6",
          }}
          options={{ suppressScrollX: true }}
        >
          <ProductOptions />

          <ul className="nav">
            {/*
              If we are on responsive, we want both links from navbar and sidebar
              to appear in sidebar, so we render here HeaderLinks
            */}
            {width <= 992 ?
              <>
                <AdminNavbarLinks />
                <MobileNavbarTiles />
              </>
            : null}
            <MerchantSidebar />
          </ul>
        </PerfectScrollbar>
      </div>
    </DatesProvider>
  );
}

export default Sidebar;
